export default "__VITE_ASSET__bG1mpj7y__"